import { seasonRange } from '@squadcore/api/shared/season'
import { addDays, isoWeekday, monthStart, nextMonth } from '@squadcore/api/shared/time'
import type { Range } from './queries'

// Route loaders use these outside the lazy page chunks, so this module stays free of components.

export type PlanSearch = { view?: 'week' | 'month'; date?: string }

/** The visible range of the plan: Monday–Sunday of the week, or the whole calendar month. */
export function planRange(view: 'week' | 'month', date: string) {
  if (view === 'week') {
    const from = addDays(date, 1 - isoWeekday(date))
    return { from, to: addDays(from, 6) }
  }
  // Inclusive last day — v1 lost it by converting local midnight to UTC.
  return { from: monthStart(date), to: addDays(nextMonth(date), -1) }
}

/**
 * The day the plan shows, inside the selected season (ARCHITECTURE "Saison wirkt überall", v1 W6):
 * the current season opens on today, a past one on its last month, a future one on its first.
 */
export function planDate(date: string | undefined, season: string, startMonth: number, today: string) {
  const r = seasonRange(season, startMonth)
  const last = addDays(r.endsOn, -1)
  const d = date ?? today
  return d < r.startsOn ? r.startsOn : d > last ? last : d
}

export type AttendanceSearch = {
  view?: 'termine' | 'heatmap'
  range?: '4w' | '3m' | 'frei'
  from?: string
  to?: string
  inaktive?: boolean
}

/** Resolve the range presets to dates; undefined = the selected season (server default). */
export function resolveRange(s: AttendanceSearch, today: string): Range {
  if (s.range === '4w') return { from: addDays(today, -27), to: today }
  if (s.range === '3m') return { from: addDays(today, -90), to: today }
  if (s.range === 'frei' && s.from && s.to) return { from: s.from, to: s.to }
  return {}
}
